import React from 'react'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import { EventHome, EventRegister, EventMenu } from '.'
import { CustomizedSnackbar } from '../../../containers'
import { MenuAppBar } from '../../../Parts/MenuAppBar'
import { LANGUAGE_SHORT_CODE } from '../../../constants';
import Word from '../../../containers/Common/Word';
import { WID } from '../../../constants/Language';

class EventRouting extends React.Component {
  render() {
    var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')

    return (
      <React.Fragment>
        <MenuAppBar title={<Word wid={WID.MENU_APP_BAR.EVENT}/>} actions={<EventMenu/>}/>
        <Switch>
          <Route exact path={`/:language(${regstr})/event`} component={EventHome}/>
          <Route exact path={`/:language(${regstr})/event/register`} component={EventRegister}/>
          <Route path={`/:language(${regstr})/event/register/:eventId`} component={EventRegister}/>
          <Route path={`/:language(${regstr})/event/:eventId`} component={EventHome}/>

          <Route exact path='/event' component={EventHome} />
          <Route exact path='/event/register' component={EventRegister} />
          <Route path='/event/register/:eventId' component={EventRegister} />
          <Route path='/event/:eventId' component={EventHome} />
        </Switch>
        <CustomizedSnackbar/>
      </React.Fragment>
    )
  }
}

export default (EventRouting)



// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventRouting.js